import AuthLayout from '##/Auth';
import DefaultLayout from '##/Default';

import Login from './Login';
import Logout from './Logout';
import Confirm from './Confirm';
import RequestReset from './RequestReset';
import ResetPassword from './ResetPassword';
import UpdatePassword from './UpdatePassword';

const routes = [
    {
        path: '/login',
        exact: true,
        layout: AuthLayout,
        component: Login,
        title: 'Login'
    },
    {
        path: '/account/confirm/:token',
        exact: true,
        component: Confirm
    },
    {
        path: '/logout',
        exact: true,
        component: Logout,
        auth: true
    },
    {
        path: '/password/request',
        exact: true,
        layout: AuthLayout,
        component: RequestReset,
        title: 'Request Password Reset'
    },
    {
        path: '/password/reset/:token',
        exact: true,
        layout: AuthLayout,
        component: ResetPassword,
        title: 'Reset Your Password'
    },
    {
        path: '/password/update',
        exact: true,
        layout: DefaultLayout,
        component: UpdatePassword,
        auth: true,
        title: 'Update Your Password'
    }
];

export default routes;
